import { Stack, TextField, Typography } from "@mui/material";
import React from "react";

interface Props {
  title?: string;
  placeholder?: string;
  disabled?: boolean;
  onUpdate: (value: string | undefined) => void;
}

export default function TitleItem({ title, placeholder, disabled, onUpdate }: Props) {
  const [draft, setDraft] = React.useState<string>();

  const handleCommit = () => {
    if (draft !== undefined && draft !== title) {
      onUpdate(draft);
    }
    setDraft(undefined);
  };

  return (
    <Stack direction="row" useFlexGap spacing={4} sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Title</Typography>
      <TextField
        sx={{ flex: 1, input: { py: 0.7, fontSize: 13 } }}
        value={draft ?? title ?? ""}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={handleCommit}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            handleCommit();
          }
        }}
      />
    </Stack>
  );
}
